<div class="progress-bar-container">
    <div class="progress-bar-icons">
        <div
            *ngFor="let urlPath of urlPathes;let i = index"
            (click)="clickToBar(i,urlPath.urlSegment!)"
            [ngStyle]="index>i ? {'background': 'none', 'border':'1px solid #0E8388'}:{'background': '#CBE4DE'} "
            class="shopping-cart-icons"
        >
            <div class="shopping-cart-items">
                <div *ngIf="index<i" class="individual-datas-icon-transparent">
                    <mat-icon>{{urlPath.matIconText}}</mat-icon>
                </div>
                <mat-icon *ngIf="index>=i ">{{urlPath.matIconText}}</mat-icon>
                <div *ngIf="index>i" class="check-circle">
                    <mat-icon>check_circle_outline</mat-icon>
                </div>
            </div>
        </div>
    </div>
    <div class="text-container">
        <div *ngFor="let urlPath of urlPathes;let i = index" class="text" [ngStyle]="index===i ? {'display':'flex'}:{'opacity':'0.5'} ">
            <p>{{'shoppingCartIcon.'+ urlPath.urlSegment | translate}}</p>
        </div>
    </div>
</div>
